import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import FuxOffsetPaginator from "../../../../../components/BaseComponents/FuxOffsetPaginator/FuxOffsetPaginator";
import LeaveRequestListItem from "./LeaveRequestListItem";
import LeaveRequestsNewRequestPage from "./LeaveRequestsNewRequestPage";
import LeaveRequestDetailPage from "./LeaveRequestDetailPage";
import ModalPortalHOC from "../../../../../components/BaseComponents/ModalPortalHOC";

export default class TimeoffRequestsFerieTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newRequestOpen: false,
            detailRequest: null
        };
        this.paginatorRef = React.createRef();
    }

    handleNewRequestOpen = _ => this.setState({newRequestOpen: true});
    handleNewRequestClose = _ => this.setState({newRequestOpen: false});
    handleDetailClose = _ => this.setState({detailRequest: null});

    resetPaginator = _ => {
        if (this.paginatorRef.current && this.paginatorRef.current.reset) {
            this.paginatorRef.current.reset();
        }
    }

    getStaffById = staffId => {
        if (!staffId) return null;
        return (this.props.staffList || []).find(s => String(s.id_dipendente) === String(staffId));
    }

    handlePageRequest = page => ModuloHRAPI.LeaveRequests.pagination(
        this.props.staffList.map(d => d.id_dipendente),
        page
    );

    handleDeleteRequest = item => {
        return ModuloHRAPI.LeaveRequests.delete(item.request_id)
            .then(message => {
                this.resetPaginator();
                return message;
            });
    }

    handleRequestCreated = _ => this.setState({newRequestOpen: false}, this.resetPaginator);

    handleRequestOpen = item => {
        const staff = this.getStaffById(item.id_dipendente);
        this.setState({detailRequest: {request: item, staff: staff}});
    }

    renderItem = (item, index) => {
        const staff = this.getStaffById(item.id_dipendente);
        return (
            <LeaveRequestListItem
                key={item.request_id || index}
                item={item}
                staff={staff}
                onOpen={this.handleRequestOpen}
            />
        );
    }

    renderEmptyPage = _ => {
        return (
            <div className={"container text-center text-muted py-4"}>
                Non ci sono richieste di ferie.
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <div className={"container py-3 text-right"}>
                    <button
                        type={"button"}
                        className={"btn btn-primary"}
                        onClick={this.handleNewRequestOpen}
                    >
                        Nuova richiesta
                    </button>
                </div>

                <div className={"container pb-4"}>
                    <FuxOffsetPaginator
                        ref={this.paginatorRef}
                        onPageRequest={this.handlePageRequest}
                        onItemRender={this.renderItem}
                        onEmptyPage={this.renderEmptyPage}
                        classItemsContainer={"list-group"}
                        visiblePagesCount={5}
                    />
                </div>
                <ModalPortalHOC>
                    {
                        this.state.newRequestOpen &&
                        <LeaveRequestsNewRequestPage
                            staffList={this.props.staffList}
                            active={this.state.newRequestOpen}
                            onDismiss={this.handleNewRequestClose}
                            onRequestCreated={this.handleRequestCreated}
                        />
                    }

                    {
                        this.state.detailRequest &&
                        <LeaveRequestDetailPage
                            staff={this.state.detailRequest.staff}
                            request={this.state.detailRequest.request}
                            active={!!this.state.detailRequest}
                            onDismiss={this.handleDetailClose}
                            onDelete={this.handleDeleteRequest}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

TimeoffRequestsFerieTab.propTypes = {
    staffList: PropTypes.array
};
